<app-multi-lineitems></app-multi-lineitems>

<div class="career_sec">
    <div class="banner">
      <img src="../../../../assets/images/career_baneer.jpg" alt="">
    </div>
    <div class="career_content">
      <div class="container">

        <h2>Exciting opportunities could be coming soon! <br> Stay tuned! </h2>
        <!-- <div class="filterCategory">
          <button *ngFor="let cat of filterCategory" (click)="getSelectCategory(cat)" class="catBtn" [ngClass]="activeCat === cat ? 'active' : ''">{{cat}}</button>
        </div>
        <div class="grid">
          <mat-card appearance="outlined" *ngFor="let job of jobList">
            <mat-card-header>
              <mat-card-title>
                {{ job.title }}
              </mat-card-title>
              <span  class="role" [ngClass]="getRoleClass(job.category)">
                {{ job.category }}
              </span>
            </mat-card-header>
            <mat-card-content>
              <p>{{ job.description }}</p>
              <span class="experience">
                Min. Experience: {{ job.experience }}
              </span>
            </mat-card-content>
            <mat-card-actions>
              <span class="location">
                <span class="icon_location">
                  <lucide-icon name="MapPin" class="icon_location"></lucide-icon>
                </span>
                {{ job.location }}
              </span>
              <button class="learn_btn" [routerLink]="['/career-detail', job.id]" mat-button>
                Learn More
                <lucide-icon name="ArrowRight" class="arrow"></lucide-icon>
              </button>
            </mat-card-actions>
          </mat-card>
        </div> -->
      </div>
    </div>
</div>